/**
 * Transcript notice lines both tiers must agree on, character for character.
 * The web recognises a moment by equality against the notice the api streamed,
 * so each literal lives here once rather than as two copies that can drift.
 */

/**
 * Said in BOTH knocks when two people knock on each other (ruling R-0905-7 d):
 * each is let through at once, and this line is what tells each of them so.
 * The web reads it by equality to know the door opened without a `recipient`
 * line ever having been written.
 */
export const MUTUAL_KNOCK_NOTICE =
  "You knocked on each other. The door is open both ways — say hello.";
